import { QuestionBase } from "./question-base";

export class LinkQuestion extends QuestionBase<number | string> {
  controlType = "link";
}
